export default __webpack_public_path__ + "static/secondSectionAnimation-be4738b31bbda86b9f495cc5b0a45ac5.svg";